import MDTypography from "components/MDTypography";
import getMinutes from "components/getMinutes";
import moment from "jalali-moment";

export default function TableData(reservationList, reservedTimes,navigate) {
  const groupedData = {};
  reservationList.forEach(item => {
    if (!groupedData[item.reservationDate]) {
      groupedData[item.reservationDate] = {};
    }
    if (!groupedData[item.reservationDate][item.subRequestGroupId]) {
      groupedData[item.reservationDate][item.subRequestGroupId] = [];
    }
    groupedData[item.reservationDate][item.subRequestGroupId].push(item);
  });

  const uniqueSubRequestGroupIds = [...new Set(reservationList.map(item => item.subRequestGroupId))];
  return {
    columns: [
      { Header: "تاریخ", accessor: "index", align: "center", width: "0px" },
      ...uniqueSubRequestGroupIds.map((item) => {
        const header = reservationList.find(reservation => reservation.subRequestGroupId === item)?.fullNameGroup?.split("-")[1];
        return {
          Header: header,
          accessor: String(item),
          align: "center",
        };
      }),
    ],
    rows: Object.keys(groupedData).map(key => ({
      index: (
        <MDTypography component="p" variant="caption" color="dark" fontWeight="medium">
          {`${String(key).slice(0, 4)}/${String(key).slice(4, 6)}/${String(key).slice(6)}`}
        </MDTypography>
      ),
      ...Object.keys(groupedData[key]).reduce((acc, key2) => {
        acc[key2] = groupedData[key][key2].map((item) => {
          const divideHours = Math.floor(getMinutes(item.startTime, item.endTime) / item.patientNumber);
          const isReserved = reservedTimes.filter(item2 => item2.reservationDate === item.reservationDate && item2.requestGroupId === item.requestGroupId && item2.subRequestGroupId === item.subRequestGroupId);

          const disabledTimes = isReserved.map(item => item.subTime);
          const isDisabled = (j) => disabledTimes.includes(moment(item.startTime, "HH:mm").add(divideHours * j, "minutes").format("HH:mm"));

          return <div style={{ display: "flex", flexWrap: "wrap" }}>
            {[...Array(item.patientNumber)].map((_, j) => (
              <div key={j} style={{
                backgroundColor: isDisabled(j) ? "#ef4444" : "white",
                border: isDisabled(j) ? "" : "1px solid #16a34a",
                padding: "0.5rem 1rem",
                borderRadius: "8px",
                margin: 1,
                cursor: !isDisabled(j) ? "pointer" : "default",
              }}>
                <MDTypography onClick={() => !isDisabled(j) && navigate('/new-reservation', { state: { reservationDate: item.reservationDate, requestGroupId: item.requestGroupId, subRequestGroupId: item.subRequestGroupId, reservationDayId: item.reservationDayId, time: moment(item.startTime, 'HH:mm').add(divideHours * j, 'minutes').format('HH:mm') }})} component="p" variant="caption" style={{ color: isDisabled(j) ? "white" : "#16a34a" }}
                              fontWeight="medium">
                  {moment(item.startTime, "HH:mm").add(divideHours * j, "minutes").format("HH:mm")}
                </MDTypography>
              </div>
            ))}
          </div>;
        });
        return acc;
      }, {}),
    })),
  };

}
